import Request from '@/services/util/request-service';
import LocalStorageService from '@/services/storage/general/local-storage-service';
import StorageScopeService from '@/services/storage/general/storage-scope-service';

const USER_GROUP_KEY = 'USR_GRP';

const UserGroupStorageService = {
  getMyGroupsCookie(): MyGroupsCookie {
    return LocalStorageService.get(StorageScopeService.scopedKey(USER_GROUP_KEY)) as MyGroupsCookie;
  },
  setMyGroupsCookie(data: MyGroupsCookie): void {
    LocalStorageService.set(StorageScopeService.scopedKey(USER_GROUP_KEY), data);
    LocalStorageService.delete(USER_GROUP_KEY);
  },
  deleteMyGroupsCookie(): void {
    LocalStorageService.delete(StorageScopeService.scopedKey(USER_GROUP_KEY));
    LocalStorageService.delete(USER_GROUP_KEY);
  },
  async initializeGroupsCookie(): Promise<MyGroupsCookie> {
    const groupResponse = await (await Request.get('user/getUsergroupList'))?.json();
    if (!groupResponse || groupResponse.error || !groupResponse.groups) {
      throw Error('Fetch request failed.');
    }

    this.setMyGroupsCookie({ groups: groupResponse.groups });
    return { groups: groupResponse.groups };
  },
};

export default UserGroupStorageService;
